import { memo, useCallback } from 'react';

import { cn } from '../../lib/styles';
import { MenuItem } from '../../designSystem/MenuItem';
import { Switch } from '../../designSystem/Switch';

interface SwitchMenuItemProps {
  label: string;
  checked: boolean;
  onCheckedChange?: (checked: boolean) => void;
  className?: string;
  disabled?: boolean;
  switchPosition?: 'left' | 'right';
  icon?: React.ReactNode;
}

const SwitchMenuItemBase = ({
  label,
  checked,
  onCheckedChange,
  className,
  disabled = false,
  switchPosition = 'left',
  icon,
}: SwitchMenuItemProps) => {
  const handleClick = useCallback(() => {
    if (disabled) return;
    onCheckedChange?.(!checked);
  }, [checked, onCheckedChange, disabled]);

  const renderContent = () => {
    if (switchPosition === 'right') {
      return (
        <>
          <div className="flex items-center flex-1 gap-2">
            {icon}
            <span className="truncate select-none">{label}</span>
          </div>

          <Switch checked={checked} onCheckedChange={onCheckedChange} disabled={disabled} />
        </>
      );
    }

    return (
      <>
        <Switch checked={checked} onCheckedChange={onCheckedChange} disabled={disabled} />
        <span className="truncate select-none">{label}</span>
      </>
    );
  };

  return (
    <MenuItem
      disabled={disabled}
      onClick={handleClick}
      className={cn('font-body-sm font-medium text-text-secondary', className)}
    >
      {renderContent()}
    </MenuItem>
  );
};

export const SwitchMenuItem = memo(SwitchMenuItemBase);
